var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Link } from 'react-router-dom';
import { Translate } from "../../../../../I18N";

import { DisplayPills } from "./DisplayPills";

const ViewParagraph = ({ paragraphData }) => /*#__PURE__*/
_jsx("div", { className: "mb-6 flex flex-col gap-3" }, void 0, /*#__PURE__*/
_jsx("div", { className: "px-4 py-3 rounded-md bg-gray-50 text-sm font-bold flex justify-between" }, void 0, /*#__PURE__*/
_jsx("div", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Entity title"), " - #", paragraphData._id, " -", ' ',
paragraphData.languages.join(', ')
), /*#__PURE__*/
_jsx("div", { className: "bg-gray-100 text-xs font-medium p-1 rounded-md" }, void 0,
paragraphData.templateName
)
), /*#__PURE__*/
_jsx("div", { className: "px-4 py-3 rounded-md leading-tight text-sm font-bold border border-gray-100" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "ID"), ":", /*#__PURE__*/
_jsx(Link, { to: `/document/${paragraphData.document}`, className: "underline" }, void 0,
paragraphData.document
)
), /*#__PURE__*/
_jsx("div", { className: "px-4 py-3 rounded-md leading-tight text-sm font-bold border border-gray-100" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Language"), ": ", /*#__PURE__*/_jsx(DisplayPills, { items: paragraphData.languages })
), /*#__PURE__*/
_jsx("div", { className: "px-4 py-3 rounded-md leading-tight text-sm font-bold border border-gray-100" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Paragraph"), ": ", paragraphData.paragraphCount
), /*#__PURE__*/
_jsx("div", { className: "px-4 py-3 rounded-md border border-gray-100 flex flex-col gap-2" }, void 0, /*#__PURE__*/
_jsx("div", { className: "leading-tight text-sm font-bold" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Text")
), /*#__PURE__*/
_jsx("div", { className: "text-sm text-gray-900 leading-[21px]" }, void 0, paragraphData.text)
)
);


export { ViewParagraph };